import React from 'react';
import styled, { css } from 'styled-components';
import {
  minBreakpointQuery,
  maxBreakpointQuery,
  sectionMargins,
} from '../styles';
import { Container, Image, Heading, HtmlContent } from './ui';

const StyledImageContent = styled.section`
  ${sectionMargins()};
`;

const StyledInner = styled.div`
  ${minBreakpointQuery.smedium`
    display: grid;
    gap: 30px;
    align-items: center;

    ${({ flip, alt }) => {
      if (alt) {
        return css`
          grid-template-columns: ${flip ? '1.1fr 1fr' : '1fr 1.1fr'};
        `;
      } else {
        return css`
          grid-template-columns: ${flip ? '1.3fr 1fr' : '1fr 1.3fr'};
        `;
      }
    }}
  `}

  ${minBreakpointQuery.medium`
    gap: 40px;
  `}

  ${minBreakpointQuery.mlarge`
    gap: 60px;
  `}

  ${minBreakpointQuery.large`
    gap: 80px;
  `}

  ${minBreakpointQuery.xxlarge`
    gap: 100px;
  `}
`;

const StyledImage = styled(Image)`
  ${maxBreakpointQuery.smedium`
    aspect-ratio: 2/1;
  `}

  ${maxBreakpointQuery.small`
    aspect-ratio: 9/5;
  `}

  ${({ flip }) => {
    if (flip) {
      return css`
        ${minBreakpointQuery.smedium`
          grid-row: 1;
          grid-column: 2;
        `}
      `;
    }
  }}
`;

const StyledContentWrapper = styled.div`
  padding-top: 15px;

  ${minBreakpointQuery.small`
    padding-top: 20px;
  `}

  ${minBreakpointQuery.smedium`
    padding-bottom: 20px;
  `}

  ${({ alt }) => {
    if (alt) {
      return css`
        ${minBreakpointQuery.smedium`
          max-width: 570px;
        `}
      `;
    }
  }}

  ${({ flip, alt }) => {
    if (flip && alt) {
      return css`
        ${minBreakpointQuery.smedium`
          margin-left: auto;
        `}
      `;
    }
  }}
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 15px;

  ${minBreakpointQuery.small`
    margin-bottom: 20px;
  `}
`;

const ImageContent = ({ image, heading, text, flip, alt }) => (
  <StyledImageContent>
    <Container wide={alt}>
      <StyledInner flip={flip} alt={alt}>
        {image && (
          <StyledImage
            src={image.url}
            alt={image.title}
            width={730}
            height={alt ? 740 : 800}
            layout="constrained"
            flip={flip}
          />
        )}
        <StyledContentWrapper flip={flip} alt={alt}>
          <StyledHeading alt={true}>{heading}</StyledHeading>
          <HtmlContent html={text} />
        </StyledContentWrapper>
      </StyledInner>
    </Container>
  </StyledImageContent>
);

export default ImageContent;
